var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryMenuIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76,
    filter: "url(#filter0_d_405_2046)",
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 16.8516H20.6406C21.3073 16.8516 21.9167 16.7969 22.4688 16.6875C23.0208 16.5781 23.4948 16.3255 23.8906 15.9297C24.2917 15.5286 24.5443 15.0547 24.6484 14.5078C24.7526 13.9609 24.8047 13.3516 24.8047 12.6797V10.0391C24.8047 9.3724 24.7526 8.76562 24.6484 8.21875C24.5443 7.67188 24.2917 7.19792 23.8906 6.79688C23.4896 6.40104 23.013 6.14844 22.4609 6.03906C21.9141 5.92969 21.3073 5.875 20.6406 5.875H8.14844C7.49219 5.875 6.88802 5.92969 6.33594 6.03906C5.78906 6.14844 5.3151 6.40365 4.91406 6.80469C4.51823 7.20052 4.26562 7.67188 4.15625 8.21875C4.05208 8.76562 4 9.36719 4 10.0234V12.6797C4 13.3516 4.05208 13.9609 4.15625 14.5078C4.26042 15.0547 4.51302 15.5286 4.91406 15.9297C5.3151 16.3255 5.78906 16.5781 6.33594 16.6875C6.88802 16.7969 7.4974 16.8516 8.16406 16.8516ZM7.95312 15.5938C7.55208 15.5938 7.15625 15.5547 6.76562 15.4766C6.38021 15.3984 6.06771 15.2422 5.82812 15.0078C5.59375 14.7734 5.4401 14.4635 5.36719 14.0781C5.29427 13.6927 5.25781 13.2995 5.25781 12.8984V9.85156C5.25781 9.4401 5.29427 9.04167 5.36719 8.65625C5.4401 8.26562 5.59375 7.95052 5.82812 7.71094C6.0625 7.47656 6.375 7.32292 6.76562 7.25C7.16146 7.17188 7.5651 7.13281 7.97656 7.13281H20.8516C21.2526 7.13281 21.6458 7.17188 22.0312 7.25C22.4219 7.32292 22.737 7.47917 22.9766 7.71875C23.2109 7.95312 23.3646 8.26302 23.4375 8.64844C23.5104 9.03385 23.5469 9.42708 23.5469 9.82812V12.8984C23.5469 13.2995 23.5104 13.6927 23.4375 14.0781C23.3646 14.4635 23.2109 14.7734 22.9766 15.0078C22.737 15.2474 22.4219 15.4062 22.0312 15.4844C21.6458 15.5573 21.2526 15.5938 20.8516 15.5938H7.95312ZM25.8672 13.3828C26.0755 13.3672 26.2917 13.276 26.5156 13.1094C26.7396 12.9375 26.9297 12.7031 27.0859 12.4062C27.2422 12.1094 27.3203 11.7604 27.3203 11.3594C27.3203 10.9635 27.2422 10.6172 27.0859 10.3203C26.9297 10.0234 26.7396 9.78906 26.5156 9.61719C26.2917 9.44531 26.0755 9.35417 25.8672 9.34375V13.3828ZM7.64062 14.6016H21.1719C21.4427 14.6016 21.6615 14.5807 21.8281 14.5391C21.9948 14.4974 22.138 14.4193 22.2578 14.3047C22.3724 14.1901 22.4505 14.0495 22.4922 13.8828C22.5391 13.7109 22.5625 13.4896 22.5625 13.2188V9.50781C22.5625 9.23698 22.5391 9.01823 22.4922 8.85156C22.4505 8.67969 22.3724 8.53646 22.2578 8.42188C22.138 8.30208 21.9948 8.22396 21.8281 8.1875C21.6615 8.14583 21.4427 8.125 21.1719 8.125H7.64062C7.36458 8.125 7.14323 8.14583 6.97656 8.1875C6.8099 8.22396 6.66927 8.30208 6.55469 8.42188C6.4401 8.53646 6.35938 8.67969 6.3125 8.85156C6.27083 9.01823 6.25 9.23698 6.25 9.50781V13.2188C6.25 13.4896 6.27083 13.7109 6.3125 13.8828C6.35938 14.0495 6.4401 14.1901 6.55469 14.3047C6.67448 14.4193 6.8151 14.4974 6.97656 14.5391C7.14323 14.5807 7.36458 14.6016 7.64062 14.6016Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_405_2046",
    x: 0,
    y: 3.875,
    width: 31.3203,
    height: 18.9766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_405_2046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_405_2046",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryMenuIcons);
export default __webpack_public_path__ + "static/media/battery_Menu_Icons.ce92e6b63e417c84a6bdfc970a0832e2.svg";
export { ForwardRef as ReactComponent };